const criteria = [
  'результаты работы',
  'профессиональные компетенции',
  'управленческий потенциал',
  'способность учиться',
  'самостоятельность',
  'ответственность',
  'коммуникация',
  'способность принимать решения',
  'готовность брать дополнительную ответственность',
  'мотивация к развитию',
  'способность работать в условиях изменений',
];

export default function WhoToInclude() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кого включать в кадровый резерв
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-10">
          Не каждый сильный сотрудник должен становиться резервистом
        </p>

        <p className="text-base md:text-lg text-gray-700 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Критерии отбора зависят от будущей роли. При отборе можно учитывать:
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {criteria.map((c) => (
            <span key={c} className="bg-white border border-gray-200 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">
              {c}
            </span>
          ))}
        </div>

        <div className="bg-teal-50 border border-teal-100 rounded-2xl p-6 md:p-8 max-w-3xl mx-auto">
          <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed mb-4">
            Лучший специалист не обязательно станет лучшим руководителем.
          </p>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">
            Высокий профессиональный результат не означает автоматической готовности к повышению. Если сотрудник готовится к руководящей должности, необходимо отдельно оценивать его управленческие компетенции.
          </p>
        </div>
      </div>
    </section>
  );
}